import { createContext } from "react";

import type { GlobalConfig } from "@login/data/globals/DefaultGlobals";
import { DefaultGlobals } from "@login/data/globals/DefaultGlobals";

const GlobalContext = createContext<GlobalConfig>(DefaultGlobals);

export { GlobalContext };
